import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function HeadphoneCustomerService(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      sx,
      viewBox,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "HeadphoneCustomerService",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M7.5 23.25h3v12h-3v-12Z", fill: theme.vars.palette.secondary.main }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.5 23.25H12c1.1935 0 2.3381.4741 3.182 1.318.8439.8439 1.318 1.9885 1.318 3.182v3c0 1.1935-.4741 2.3381-1.318 3.182-.8439.8439-1.9885 1.318-3.182 1.318h-1.5v-12Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.1083 44.5724c-1.257-.0057-2.5113-.1161-3.75-.33-.0985-.0158-.1929-.0508-.2779-.103-.085-.0523-.1588-.1208-.2173-.2016-.0585-.0807-.1005-.1723-.1236-.2693-.0232-.097-.027-.1976-.0112-.2961.0157-.0985.0508-.193.103-.2779.0523-.085.1207-.1588.2015-.2173.0808-.0585.1723-.1005.2693-.1237.0971-.0231.1977-.0269.2962-.0111 4.1175.69 7.11.27 8.9025-1.2525 1.5-1.2675 2.25-3.315 2.25-6.255 0-.1989.079-.3897.2197-.5304.1406-.1406.3314-.2196.5303-.2196.1989 0 .3897.079.5303.2196.1407.1407.2197.3315.2197.5304 0 3.36-.93 5.85-2.76 7.4025-1.515 1.2975-3.6525 1.935-6.3825 1.935Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M33 35.25h-3v-12h3v12Z", fill: theme.vars.palette.secondary.main }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M30 35.25h-1.5c-1.1935 0-2.3381-.4741-3.182-1.318C24.4741 33.0881 24 31.9435 24 30.75v-3c0-1.1935.4741-2.3381 1.318-3.182.8439-.8439 1.9885-1.318 3.182-1.318H30v12Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M35.25 29.25c-.1989 0-.3897-.079-.5303-.2197-.1407-.1406-.2197-.3314-.2197-.5303V15.75c0-.1989.079-.3897.2197-.5303.1406-.1407.3314-.2197.5303-.2197.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303V28.5c0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Zm-30 0c-.19891 0-.38968-.079-.53033-.2197C4.57902 28.8897 4.5 28.6989 4.5 28.5V18c0-7.5 5.8575-12.75 14.25-12.75h3c2.7545.07496 5.4535.79145 7.8825 2.0925.1502.1092.2545.27023.2928.45191.0382.18168.0078.3711-.0855.53161-.0934.16052-.2429.28071-.4197.33732-.1769.05661-.3684.04563-.5376-.03084C26.6791 7.47084 24.2397 6.82702 21.75 6.75h-3C11.25 6.75 6 11.3775 6 18v10.5c0 .1989-.07902.3897-.21967.5303-.14065.1407-.33142.2197-.53033.2197Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.5 27.75h3v3h-3c-.39782 0-.77936-.158-1.06066-.4393C3.15804 30.0294 3 29.6478 3 29.25c0-.3978.15804-.7794.43934-1.0607S4.10218 27.75 4.5 27.75Zm31.5 3h-3v-3h3c.3978 0 .7794.158 1.0607.4393s.4393.6629.4393 1.0607c0 .3978-.158.7794-.4393 1.0607S36.3978 30.75 36 30.75Zm-17.25 15c1.2426 0 2.25-1.0074 2.25-2.25s-1.0074-2.25-2.25-2.25-2.25 1.0074-2.25 2.25 1.0074 2.25 2.25 2.25Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M42 3H30c-.7956 0-1.5587.31607-2.1213.87868C27.3161 4.44129 27 5.20435 27 6v7.5c0 .7956.3161 1.5587.8787 2.1213.5626.5626 1.3257.8787 2.1213.8787v3l3-3h9c.7956 0 1.5587-.3161 2.1213-.8787.5626-.5626.8787-1.3257.8787-2.1213V6c0-.79565-.3161-1.55871-.8787-2.12132C43.5587 3.31607 42.7956 3 42 3Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M40.5 8.25h-9c-.1989 0-.3897-.07902-.5303-.21967-.1407-.14065-.2197-.33142-.2197-.53033 0-.19891.079-.38968.2197-.53033.1406-.14065.3314-.21967.5303-.21967h9c.1989 0 .3897.07902.5303.21967.1407.14065.2197.33142.2197.53033 0 .19891-.079.38968-.2197.53033-.1406.14065-.3314.21967-.5303.21967Zm0 4.5h-9c-.1989 0-.3897-.079-.5303-.2197-.1407-.1406-.2197-.3314-.2197-.5303 0-.1989.079-.3897.2197-.5303.1406-.1407.3314-.2197.5303-.2197h9c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
            fill: theme.vars.palette.primary.light
          }
        )
      ]
    }
  );
}
HeadphoneCustomerService.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "HeadphoneCustomerService"
};
validateTidalLicense();
export {
  HeadphoneCustomerService
};
//# sourceMappingURL=HeadphoneCustomerService.js.map
